// src/features/house/actionTypes.js
export const FETCH_HOUSES_REQUEST = 'house/FETCH_HOUSES_REQUEST';
export const FETCH_HOUSES_SUCCESS = 'house/FETCH_HOUSES_SUCCESS';
export const FETCH_HOUSES_FAILURE = 'house/FETCH_HOUSES_FAILURE';

export const ADD_HOUSE_SUCCESS = 'house/ADD_HOUSE_SUCCESS';
export const UPDATE_HOUSE_SUCCESS = 'house/UPDATE_HOUSE_SUCCESS';
export const DELETE_HOUSE_SUCCESS = 'house/DELETE_HOUSE_SUCCESS';
